import { defineComponent, openBlock, createElementBlock, createElementVNode } from 'vue';
import _export_sfc from './_virtual/plugin-vue_export-helper.mjs';

const _sfc_main = defineComponent({
  name: "Wancheng"
});
const _hoisted_1 = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2 = /* @__PURE__ */ createElementVNode("path", {
  d: "M8 1C4.13406 1 1 4.13406 1 8C1 11.8659 4.13406 15 8 15C11.8659 15 15 11.8661 15 8C15 4.13391 11.8659 1 8 1ZM11.4472 6.40906L7.38125 10.4748C7.32321 10.5329 7.25431 10.5789 7.17848 10.6103C7.10265 10.6417 7.02138 10.6579 6.9393 10.6579C6.85722 10.6579 6.77594 10.6417 6.70011 10.6103C6.62428 10.5789 6.55538 10.5329 6.49734 10.4748L4.55281 8.53031C4.49477 8.47228 4.44873 8.40337 4.41732 8.32754C4.38591 8.25171 4.36974 8.17044 4.36974 8.08836C4.36974 8.00628 4.38591 7.92501 4.41732 7.84917C4.44873 7.77334 4.49477 7.70444 4.55281 7.64641C4.61085 7.58837 4.67975 7.54233 4.75558 7.51091C4.83141 7.4795 4.91269 7.46334 4.99477 7.46334C5.07684 7.46334 5.15812 7.4795 5.23395 7.51091C5.30978 7.54233 5.37868 7.58837 5.43672 7.64641L6.93937 9.14906L10.5633 5.52516C10.6213 5.46712 10.6902 5.42108 10.766 5.38967C10.8419 5.35825 10.9232 5.34209 11.0052 5.34209C11.0873 5.34209 11.1686 5.35825 11.2444 5.38967C11.3202 5.42108 11.3892 5.46712 11.4472 5.52516C11.5052 5.58319 11.5513 5.65209 11.5827 5.72792C11.6141 5.80376 11.6303 5.88503 11.6303 5.96711C11.6303 6.04919 11.6141 6.13046 11.5827 6.20629C11.5513 6.28212 11.5052 6.35103 11.4472 6.40906Z",
  fill: "#0FBD81"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _hoisted_3);
}
var wancheng = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render]]);

export { wancheng as default };
